import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

export const StyledSearchInputContainer = styled.div<{ isError?: boolean; isLoading?: boolean }>`
    width: 320px;
    padding: 10px 0;

    .SearchInput-container > div:first-child {
        top: 7px;
    }

    .SearchInput-container .SearchInput {
        width: 100%;
        box-sizing: border-box;
        box-shadow: none;
        margin-bottom: 0;
        height: 40px;
        padding: ${({ isLoading }) => (isLoading ? "5px 40px 5px 45px" : "5px 2px 5px 45px")};
        border: ${({ isError }) =>
            isError ? `1px solid ${colorsPalettes.red[400]}` : `1px solid ${colorsPalettes.midnight[50]}`};

        &:focus {
            border-color: ${({ isError }) => (isError ? colorsPalettes.red[400] : colorsPalettes.blue[400])};
            box-shadow: ${({ isError }) => (isError ? "none !important" : "0 3px 5px 0 #2a3e521f")};
        }
    }
`;

export const StyledContactCardsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
    max-width: 604px;
    margin-bottom: 12px;
`;

export const StyledContactCard = styled.div<{ isDisabled: boolean }>`
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    padding: 8px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    box-shadow: 0 3px 6px 0 #0e1e3e14;
    border: 1px solid transparent;
    max-width: 196px;
    min-width: 196px;
    box-sizing: border-box;
    min-height: 58px;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

    ${({ isDisabled }) =>
        isDisabled
            ? css`
                  background-color: ${colorsPalettes.bluegrey[200]};
                  box-shadow: none;
                  border: 1px solid ${colorsPalettes.midnight[50]};
              `
            : css`
                  &:hover {
                      border: 1px solid ${colorsPalettes.carbon[100]};
                  }
              `}

    ${SWReactIcons} {
        display: flex;
    }
`;
